<router-outlet></router-outlet>
<!-- <ngx-spinner name="reportspinner"><p style="color: white; margin-top: 50px;" > Fetching Wallet2 Balance... </p></ngx-spinner> -->